import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { ApiResponse } from '../../models/api-response.model';
import { PaginatedResponse } from '../../models/paginated-response';
import { LateFeeConfig, LateFeeConfigRequest, LateFeeType } from '../../models/late-fee-config.model';

@Injectable({ providedIn: 'root' })
export class LateFeeConfigService {
  private readonly apiUrl = `${environment.apiGatewayBaseUrl}/api/LateFeeConfig`;

  constructor(private http: HttpClient) {}

  getLateFeeConfigsPaginated(
    pageNumber: number,
    pageSize: number,
    companyId?: number | null,
    isCurrent?: boolean | null,
    isActive?: boolean | null
  ): Observable<PaginatedResponse<LateFeeConfig>> {
    let params = new HttpParams()
      .set('pageNumber', pageNumber)
      .set('pageSize', pageSize);

    if (companyId != null) params = params.set('companyId', companyId);
    if (isCurrent != null) params = params.set('isCurrent', isCurrent);
    if (isActive != null)  params = params.set('isActive', isActive);

    return this.http.get<PaginatedResponse<LateFeeConfig>>(this.apiUrl, { params });
  }

  getLateFeeTypes(): Observable<ApiResponse<LateFeeType[]>> {
    return this.http.get<ApiResponse<LateFeeType[]>>(`${this.apiUrl}/types`);
  }

  createLateFeeConfig(payload: LateFeeConfigRequest): Observable<ApiResponse<number>> {
    return this.http.post<ApiResponse<number>>(this.apiUrl, payload);
  }

  updateLateFeeConfig(lateFeeConfigId: number, payload: LateFeeConfigRequest): Observable<ApiResponse<number>> {
    return this.http.put<ApiResponse<number>>(`${this.apiUrl}/${lateFeeConfigId}`, payload);
  }

  deleteLateFeeConfig(lateFeeConfigId: number): Observable<ApiResponse<boolean>> {
    return this.http.delete<ApiResponse<boolean>>(`${this.apiUrl}/${lateFeeConfigId}`);
  }
}
